import { Pipe, type PipeTransform } from '@angular/core';
import { ensureItemsArray } from '../functions/ensure-items-array';

@Pipe({
  name: 'ensureItemsArray',
})
export class EnsureItemsArrayPipe implements PipeTransform {
  transform<T>(values: T | T[] | null | undefined): T[] {
    return ensureItemsArray(values);
  }
}
